import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";

const BrandsTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  can_create,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang] = useState("en");
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          table={{
            list: data,
            listTitle: t("lookups_brands.list_title"),
            createBtnTitle: can_create && t("lookups_brands.add"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "image_url",
                Header: t("common.image"),
              },
              {
                accessor: "name_en",
                Header: t("lookups_brands.brand_name_en"),
                sort: true,
                sortKey: "name_en",
              },
              {
                accessor: "name_ar",
                Header: t("lookups_brands.brand_name_ar"),
                sort: true,
                sortKey: "name_ar",
              },
              {
                accessor: "display_priority",
                Header: t("lookups_brands.display_priority"),
                sort: true,
              },
              {
                accessor: "products_count",
                Header: t("lookups_brands.products_count"),
              },
              {
                accessor: "is_active_label",
                Header: t("lookups_brands.is_active"),
                sort: true,
              },
              {
                accessor: "created_at",
                Header: t("details.created_at"),
                sort: true,
              },
              {
                accessor: "updated_at",
                Header: t("details.updated_at"),
                sort: true,
              },
              { accessor: "Actions", Header: t("cart_logs.actions") },
            ],
            isSearch: true,
            searchInputPlaceholder: t("lookups_brands.search_placeholder"),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList,
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
            emptyListMsg: t("lookups_brands.empty"),
          }}
          form={{
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () =>
              structure(supportedLang, [{ id: "1", name: "test" }], t),
            validationSchema: validationSchema,
            deleteFun: deleteFun,
            title: id ? t("lookups_brands.edit") : t("lookups_brands.add"),
            submitTitle: id
              ? t("admin_users.btn_update")
              : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default BrandsTemplate;
